import { parseJsonOrOriginalString } from '@utils/json';

export const parseDescriptionWithBreadCrumbs = (description: string) => {
  // Try to parse the JSON or return the original string
  const jsonDataOrString = parseJsonOrOriginalString(description);

  // Check if it's an object with the desired properties
  if (typeof jsonDataOrString === 'object' && jsonDataOrString !== null) {
    const { description = '', breadcrumbs = '' } = jsonDataOrString;
    return { description, breadcrumbs };
  }

  // If it's a simple string, return it as description with empty breadcrumbs
  return { description: jsonDataOrString, breadcrumbs: '' };
}

